exports.install = function (Vue, options) {

  Vue.prototype.go = function (url) {
    console.log("go:", url);
    if (url == 'refresh') {
      location.reload();
    } else {
      var reg = /(http|https):\/\/([\w.]+\/?)\S*/ig;
      if (url.match(reg)) {
        this.navigateToUrl(url);
      } else {
        this.$router.push(url)
      }
    }
    return false;
  };
  Vue.prototype.init = function () {
    var $web_conf = this.$web_conf;
    var cn_tmp_hosts = $web_conf['cn_tmp_hosts'];
    this.$web_conf.set_host = cn_tmp_hosts[0];

    if (this.create_axios) {
      this.create_axios();
    }
    this.update_row_count();
    this.$axios.get("/app/comic/init").then((response) => {
      this.$store.commit('init', {
        'data': response.data,
        'time': new Date().valueOf()
      });
    })
    this.update_user_info();
  };

  Vue.prototype.set_title = function (t) {
    setTimeout(() => {
      document.title = t + "  -- " + this.$web_conf.application_name;
    }, 50)
  };

  Vue.prototype.update_row_count = function () {
    var ROW_COUNT = parseInt(window.innerWidth / 260);
    ROW_COUNT = ROW_COUNT < 3 ? 3 : ROW_COUNT;
    ROW_COUNT = ROW_COUNT > 8 ? 8 : ROW_COUNT;
    Vue.prototype._g.COMMON_ROW_COUNT = ROW_COUNT;
  };
  Vue.prototype.is_mobile = function () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
  };

  Vue.prototype.update_url_param = function (update_params) {
    var url_vars = this.getUrlVars();
    var pathname = location.pathname;
    for (let k in url_vars) {
      pathname = this.updateQueryStringParameter(pathname, k, url_vars[k])
    }
    for (let k in update_params) {
      pathname = this.updateQueryStringParameter(pathname, k, update_params[k])
    }
    return pathname;
  };

  Vue.prototype.update_user_info = function () {
    this.$axios.get('/app/user/info', {
      params: {}
    }).then((response) => {
      console.log("user info:", response)
      var login = response.data.login;
      if (!login) {
        //未登录
        this.$store.commit('loginout');
        console.log("token无效或过期")
        return;
      }
      var message_notify = response.data.message_notify;
      if (message_notify) {
        var num = parseInt(message_notify.num);
      }
      console.log("message_notify:", message_notify);
      this.message_notify = message_notify;
      if (this.message_notify.num <= 0) {
        this.message_notify.num = undefined;
      }

      var user = response.data.user;
      if (user) {
        console.log("update user:", user);
        this.$store.commit('login', {
          'userinfo': user,
          'token': user.token
        });
      }
    }).catch(function (error) {

    });
  }
};

